import { useState, useEffect } from 'react';

interface TypingTextProps {
  text: string;
  isDarkMode: boolean;
  speed?: number;
}

export function TypingText({ text, isDarkMode, speed = 150 }: TypingTextProps) {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    }
  }, [currentIndex, text, speed]);

  // Blinking cursor effect
  useEffect(() => {
    const interval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 530);

    return () => clearInterval(interval);
  }, []);

  return (
    <span className={`relative z-10 bg-clip-text text-transparent bg-gradient-to-r ${isDarkMode ? 'from-yellow-300 via-amber-300 to-yellow-300' : 'from-yellow-400 via-yellow-500 to-yellow-400'} bg-[length:200%] animate-gradient`}>
      {displayedText}
      <span 
        className={`inline-block w-1 h-16 ml-1 ${showCursor ? 'opacity-100' : 'opacity-0'} ${isDarkMode ? 'bg-yellow-300' : 'bg-yellow-500'} transition-opacity duration-100`}
        style={{ verticalAlign: 'middle' }}
      />
    </span>
  );
}
